<template>
  <v-parallax
    src="/home-image.jpg"
    height="100%"
  >
    <v-app style="background: rgb(0,0,0,0)">
      <v-layout align-center justify-center>
        <v-flex xs12 sm6 md5 lg4>
          <v-card color="rgb(255,255,255,0.1)" style="border-radius: 20px;">
            
            <br>
            <v-card-title>
              <v-layout row wrap align-center justify-center class="mt-3">
                <v-img src="/CB-logo.png" max-height="115" contain></v-img>
              </v-layout>
            </v-card-title>
            <br>
            <v-layout justify-center>
              <v-flex xs8 >
                <span class="white--text">
                <v-text-field autofocus v-model="email" label="Email address" suffix="@iitk.ac.in"  color="white"  dark></v-text-field>
                </span>
                <v-flex xs12 sm12>
                  <v-text-field
                    v-model="password"
                    :append-icon="show1 ? 'visibility' : 'visibility_off'"
                    :type="show1 ? 'text' : 'password'"
                    name="input-10-1"
                    label="Password"
                    counter
                    @click:append="show1 = !show1"
                    dark
                    color="white"
                    @keyup.enter="login"
                  ></v-text-field>
                </v-flex>
              </v-flex>
            
            </v-layout>
            <br><br>
            <v-layout align-center justify-center pb-3>
              <v-btn depressed large color="amber" @click="login" @keyup.enter="login" :loading="loading" round>LOGIN</v-btn>
            </v-layout>
            <br>
          </v-card>
        </v-flex>
      </v-layout>
      <v-snackbar
        v-model="snackbar"
        :color="color"
        :multi-line="mode === 'multi-line'"
        :timeout="timeout"
        :vertical="mode === 'vertical'"
      >
        {{ text }}
    </v-snackbar>
    </v-app>
  </v-parallax>
</template>

<script>
import firebase from 'firebase'
export default {
  name: "Login",
  data() {
    return {
      loading: false,
      snackbar: false,
      color: '',
      mode: '',
      timeout: 6000,
      text: '',
      show1 : false,
      password : '',
      email : ''
    }
  },
  methods : {
    login : function () {
      this.loading = "true";
      var vm=this;
      firebase.auth().signInWithEmailAndPassword(this.email+'@iitk.ac.in',this.password).then( function () {
        vm.color='success'
        vm.text="Logged In"
        vm.snackbar=true;
        setTimeout(function () {
          vm.$router.push('/home');
        },1500);
      }).catch( function (error) {
        vm.password='';
        vm.color='error'
        vm.text=error.message+' ('+error.code+')';
        vm.snackbar=true;
        vm.loading=false;
      })
    },
  }
};
</script>